<app-stackable-notifications-manager class="tw-fixed tw-right-[32px] tw-bottom-[32px] tw-z-50"></app-stackable-notifications-manager>
<div class="app-content">
  <div *ngIf="lenderUser$ | async" class="app-chrome">
    <app-alert *ngIf="siteIsUpdated" class="site-updated-alert" level="info" message="Updates for Pipeline available! Please hard refresh at your earliest convenience. Windows: Shift+Ctrl+R. Mac: Shift+Command+R."></app-alert>
    <app-alert *ngIf="!isSupported" class="unsupported-browser-alert" level="warning" message="You are not using a supported device or browser and may have a less than optimal experience. For a supported experience, please use the most recent version of Chrome on a desktop computer."></app-alert>
    <app-global-header
      [user]="lenderUser$ | async"
      (globalHeaderLoaded)="headerLoaded()"
      (cxDrawerToggle)="globalCxSideNav.toggle()"
      (notificationDrawerToggle)="globalNotificationSideNav.toggle()"
    ></app-global-header>
    <app-callbar></app-callbar>
    <app-notifications-smart [suppressNotifications]="suppressNotifications" [user]="lenderUser$ | async"></app-notifications-smart>
    <app-global-borrower-tabs-smart *ngIf="showGlobalBorrowersTabs"></app-global-borrower-tabs-smart>
  </div>
  <mat-drawer-container>
    <mat-drawer-content>
      <div class="app-page">
        <div class="app-page" *ngIf="globalHeaderLoaded || loginPage; else loading">
          <router-outlet></router-outlet>
        </div>
        <ng-template #loading>
          <app-loading></app-loading>
        </ng-template>
      </div>
    </mat-drawer-content>
    <mat-drawer #globalNotificationSideNav mode="over" position="end" opened="false" class="tw-w-1/4">
      <app-notifications-history-smart
        class="tw-flex tw-h-full"
        (clickOutside)="handleClickedOutsideNotifications(globalNotificationSideNav)"
      ></app-notifications-history-smart>
    </mat-drawer>
    <mat-drawer #globalCxSideNav
      [mode]="(dispositionLocked$ | async) ? 'over' : 'side'"
      [disableClose]="!!(dispositionLocked$ | async)"
      position="start" opened="false" class="!tw-w-1/4">
      <app-cx-interaction-smart
        *ngIf="canViewCxInteractions"
        [user]="lenderUser$ | async"
        [callId]="interactionCallId$ | async"
        [forcedPrefill]="forcedPrefill$ | async"
        [livePrefill]="livePrefill$ | async"
        [locked]="!!(dispositionLocked$ | async)"
        class="tw-flex tw-justify-center"
        (savedSuccessfully)="onForcedDispositionComplete()"
        (cxDrawerClose)="onCxDrawerCloseRequested(globalCxSideNav)"
      ></app-cx-interaction-smart>
    </mat-drawer>
  </mat-drawer-container>
</div>
